var map = {
	"./Apfel.png": 53926,
	"./Erdbeere.png": 29042,
	"./Hafer.png": 33064,
	"./Kartoffeln.png": 77909,
	"./Möhren.png": 65676,
	"./RoteBeete.png": 28322,
	"./Sellerie.png": 93015,
	"./Sommerweizen.png": 17932,
	"./Spargel.png": 50908,
	"./Winterdurum.png": 12007,
	"./Wintergerste.png": 98589,
	"./Winterraps.png": 6996,
	"./Winterroggen.png": 87741,
	"./Wintertriticale.png": 25679,
	"./Winterweizen.png": 16528,
	"./Zuckerrüben.png": 63522,
	"./Zwiebeln.png": 21874,
	"./default.png": 31526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81626;